//on document ready
document.addEventListener("DOMContentLoaded", function(event) {
    const reviewBoxes = document.querySelector('.reviews-boxes');
    if(reviewBoxes){
        const config = {
            adaptiveHeight: true,
            prevNextButtons: false,
            draggable: true,
            pageDots: true,
            contain: true
        };
        import(flu.chunks.flickity).then(({ Flickity }) => {
            slider = new Flickity(reviewBoxes, config);
        });
    }
});
